module.exports = __webpack_public_path__ + "img/17.1.e8398af3.jpg";